import {Switch} from "../inputs";
import {Link} from "react-router-dom";
import {PolLogo, PolTextLogo} from "../logo";
import {ROOT_URL} from "../../constants/global";
import {SidebarItem} from "./index";
import {SIDEBAR_ROUTES} from "../../constants/routes";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../../redux/slices/user-slice";
import {toast} from "react-toastify";
import Cookies from "js-cookie";

export default function MobileSidebar({open, onClose}) {

    const layout = useSelector(state => state.layout.data);
    const dispatch = useDispatch();

    useEffect(() => {
        if (open) {
            document.body.classList.add("block-scroll")
        } else {
            document.body.classList.remove("block-scroll")
        }
    }, [open]);

    const changePanel = () => {
        window.location.replace(process.env.REACT_APP_EMPLOYER_URL);
    }

    const logoutHandler = () => {
        // Cookies.remove(process.env.REACT_APP_FREELANCER_TOK);
        Cookies.remove(process.env.REACT_APP_FREELANCER_TOK, {
            domain: `.${process.env.REACT_APP_MAIN_DOMAIN}`
        });
        toast.success("از حساب کاربری خود خارج شدید");
        dispatch(logout());
        window.location.replace(process.env.REACT_APP_MAIN_URL);
    }

    return (
        <div
            className={`container flex flex-col duration-300 bg-white z-40 h-full w-full fixed top-0 right-0 pt-8 overflow-y-auto ${open ? "" : "translate-x-full"}`}>
            <div className="flex-between m-padding-x">
                <Link to={ROOT_URL + "/dashboard"} className="group flex items-center gap-x-1.5">
                    <PolLogo classes="group-hover:fill-pol-main-purple duration-300"/>
                    <PolTextLogo classes="group-hover:fill-pol-main-purple duration-300"/>
                </Link>

                <button onClick={onClose}>
                    <i className="icon-times text-pol-gray"/>
                </button>
            </div>
            <div className="flex-between py-3 m-padding-x border-y border-y-pol-light-purple-2 mt-5">
                {
                    <h2 className="text-sm font-semibold text-pol-dark">پنل فریلنسر</h2>
                }
                <Switch
                    classes={{
                        firstLabelClasses: "text-pol-main-dark-color",
                        secondLabelClasses: "text-pol-main-dark-color",
                        barClasses: "before:bg-pol-main-dark-color bg-pol-light-orange-2"
                    }}
                    checked
                    onChange={changePanel}
                />
            </div>
            <div className="relative flex-between cursor-pointer w-full pr-[1.875rem]">
                <span
                    className="absolute -left-[0.938rem] top-0 w-[calc(100%+1.875rem)] h-full py-4"
                    style={{background: "linear-gradient(235deg, rgba(252,250,255,0) 0%, rgba(245,240,255,0.92) 60%)"}}
                />
                <div className="relative flex items-center py-4">
                    <div
                        className="py-1.5 w-9 h-9 min-w-[2.25rem] rounded-[0.625rem] outline outline-2 outline-pol-light-purple-2 flex-center">
                        {
                            layout.avatar_thumbnail ?
                                <img
                                    className="w-full he-full object-cover"
                                    alt={layout.name}
                                    src={layout.avatar_thumbnail}
                                /> : <i className="icon-pol-person text-pol-light-purple-2 text-xl"/>
                        }
                    </div>
                    <div className="mr-2">
                        <p className="font-semibold text-pol-dark-2 text-[0.938rem]">
                            {layout.name || ""}
                        </p>
                        <button
                            onClick={logoutHandler}
                            className="block text-pol-red font-semibold text-[0.625rem]"
                        >
                            خروج از حساب
                        </button>
                    </div>
                </div>
                <Link
                    to={ROOT_URL+"/profile"}
                    className="block px-[1.875rem] h-full py-4"
                >
                    <i className="icon-left-arrow inline-block mt-1"/>
                </Link>
            </div>
            <nav className="mt-4 pb-[4.5rem] flex flex-col gap-y-2.5 sidebar-links m-padding-x">
                {
                    SIDEBAR_ROUTES.filter(route => route.showInMenu).map(item => (
                        <SidebarItem
                            layout={layout}
                            opened
                            {...item} />
                    ))
                }
            </nav>
            <div className="mx-[0.938rem] pt-3.5 border-t border-t-pol-light-purple-2 mt-auto">
                <Link to="/" className="mb-3.5 block">
                    <p className="text-center text-pol-dark-2 text-sm font-semibold">
                        <i className="icon-logout ml-3.5"/>
                        <span>لندینگ پیج من</span>
                    </p>
                </Link>
                <div className="h-[0.563rem] w-[60%] rounded-t-xl bg-pol-main-color mx-auto"/>
            </div>
        </div>
    )
}
